/* ==========================================================================
   PWR FOOTER
   ----------------------------------------------------------------------------
   The ONLY behaviour the footer needs: collapse the link columns into
   accordions on MOBILE, expanded on desktop. Built on native <details>, so
   it degrades gracefully — with JS off, every column is simply open (readable).

   Reused, NOT reimplemented:
     - Subtle fade reveal -> engine [data-pwr-reveal] (in markup)
     - Newsletter submit  -> Shopify {% form 'customer' %} (Dawn's mechanism)
     - Lifecycle / utils   -> JS Core (registerSection, viewport bus)

   This controller only toggles the `open` attribute of the column <details>
   at the mobile breakpoint. No layout is written by JS (CSS owns all styling),
   so it is CLS-safe. Registered via PWR.registerSection => Theme Editor safe.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var utils = PWR.utils;
  var Section = PWR.Section;

  var MOBILE = 749; // <= this width => accordion (collapsed) behaviour.

  function Footer(root) {
    Section.call(this, root);
  }
  Footer.prototype = Object.create(Section.prototype);
  Footer.prototype.constructor = Footer;

  Footer.prototype.init = function () {
    this.columns = this.$$('[data-pwr-footer-accordion]');
    if (!this.columns.length) return;

    this._apply = this._apply.bind(this);
    this._apply();

    // React to breakpoint changes via the Core viewport bus (no own listener).
    var self = this;
    this._unsub = PWR.bus.on(PWR.EVENTS.breakpointChange, this._apply);
    if (!this._unsub) {
      // Fallback: matchMedia listener if the bus event isn't present.
      this._mq = window.matchMedia('(max-width: ' + MOBILE + 'px)');
      this._mqHandler = function () { self._apply(); };
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._mqHandler);
      else if (this._mq.addListener) this._mq.addListener(this._mqHandler);
    }
    this.addCleanup(function () {
      if (self._unsub) self._unsub();
      if (self._mq) {
        if (self._mq.removeEventListener) self._mq.removeEventListener('change', self._mqHandler);
        else if (self._mq.removeListener) self._mq.removeListener(self._mqHandler);
      }
    });
  };

  Footer.prototype._isMobile = function () {
    return window.matchMedia('(max-width: ' + MOBILE + 'px)').matches;
  };

  Footer.prototype._apply = function () {
    var mobile = this._isMobile();
    for (var i = 0; i < this.columns.length; i++) {
      var details = this.columns[i];
      // Desktop: force open + disable the toggle affordance.
      // Mobile: collapse (first one may stay open for orientation) and enable.
      if (mobile) {
        details.open = false;
        details.removeAttribute('data-locked');
      } else {
        details.open = true;
        details.setAttribute('data-locked', '');
      }
    }
  };

  PWR.registerSection('pwr-footer', function (root) { return new Footer(root); });
})();
